import SelectCar from "../images/plan/icon1.png";
import Contact from "../images/plan/icon2.png";
import Drive from "../images/plan/icon3.png";

function PlanTrip() {
  return (
    <>
      <section className="plan-section">
        <div className="container">
          <div className="plan-container">
            <div className="plan-container__title">
              <h3>Plan your trip now</h3>
              <h2>Quick & easy car rental</h2>
            </div>

            <div className="plan-container__boxes">
              <div className="plan-container__boxes__box">
                <img src={SelectCar} alt="icon_img" />
                <h3 style={{ fontFamily: 'Montserrat'}}>Select Car</h3>
                <p style={{ fontFamily: 'Montserrat'}}>
                We offer a wide range of ride options to suit your needs. Whether it’s a quick trip across town or a longer journey, we’ve got you covered with safe, reliable, and affordable rides.
                </p>
              </div>

              <div className="plan-container__boxes__box">
                <img src={Contact} alt="icon_img" />
                <h3 style={{ fontFamily: 'Montserrat'}}>Contact Operator</h3>
                <p style={{ fontFamily: 'Montserrat'}}>
                Our professional and friendly drivers are always ready to provide a smooth and comfortable ride while ensuring your safety and convenience.
                </p>
              </div>

              <div className="plan-container__boxes__box">
                <img src={Drive} alt="icon_img" />
                <h3 style={{ fontFamily: 'Montserrat'}}>Let's Drive</h3>
                <p style={{ fontFamily: 'Montserrat'}}>
                Wherever you're headed, we've got you covered with our reliable and convenient ride options.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default PlanTrip;
